import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react";
import useStores from "../../../../utils/useStores";

import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

import SubjectSimpleEditComponent from './Component';

import "./style.css";

const SubjectSimpleEditContainer = observer(() => {
    const { user, subject } = useParams<{ user: string; subject: string }>();
    const rootStore = useStores();
    const [subjectObj, setSubjectObj] = useState();

    useEffect(() => {
        loadData();
    }, []);

    // observer re-renders when this changes — no need to cache in local state
    const isLoggedIn = !!rootStore.profileStore.isLoggedIn;

    const loadData = async() => {
        if (!user || !subject) return;
        await rootStore.subjectStore.fetchOne(user, subject);
        let tmpSubject = rootStore.subjectStore.subjects.get(`${user}/${subject}`);
        rootStore.uiStore.setSimpleEditorShownFields(
            tmpSubject ? tmpSubject.allFacts.slice(0, 2) : []
        );
        setSubjectObj(tmpSubject);
    }
    let quizSubject: any = subjectObj;
    if (!quizSubject || !quizSubject.objects) {
        return (
            <Grid container direction="row">
                <CircularProgress color="inherit" />
            </Grid>
        );
    }

    let allFacts = quizSubject.allFacts;
    
    const addNewObject = () => {
        rootStore.objectStore.addNewEmptyObject(subjectObj)
    }

    return (
        <SubjectSimpleEditComponent 
            addNewObject={addNewObject}
            subject={quizSubject}  
            allFacts={allFacts} 
            shownFacts={rootStore.uiStore.simpleEditorShownFieldList} 
            isLoggedIn={isLoggedIn}
            objectStore={rootStore.objectStore}
            toggleFact={rootStore.uiStore.toggleSimpleEditorShownField}
            showFact={rootStore.uiStore.showSimpleEditorField}
        />
    );
});

export default SubjectSimpleEditContainer;
